import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const VacancyFilter = ({ form }) => {
  return (
    <div className="flex flex-col w-full p-4 mt-14 rounded-md shadow-[0_0_3px_#C4C4C4]">
      <div className="mb-6">
        <p className="text-xl font-medium">Фильтр</p>
      </div>

      <div className="mb-2">
        <select id="gender" name="gender" className="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 outline-none ring-gray-300 focus:ring-1 focus:ring-blue-500 sm:text-sm sm:leading-6" {...form.register('filter.type')}>
          <option value="all"> Все </option>
          <option value={'vacancy'}> Вакансии </option>
          <option value={'hr'}> Поиск и подбор </option>
        </select>
      </div>
      <div className="mb-2 px-2 flex flex-col">
        <button
          type="button"
          className="bg-transparent w-full text-gray-500 font-semibold py-2 px-4  rounded-lg"
          onClick={() => {
            form.setValue('filter.type', 'all');
          }}>
          Сбросить
        </button>
      </div>
    </div>
  );
};

export default VacancyFilter;
